import { PUBLIC_INPUTS, validatePublic } from "../../../../lib/copy/src/agent-contracts.mjs";
import { agentQuoteQuery } from "../../../../lib/copy/src/agent-public.mjs";
export interface AgentSelection { start?: string; end?: string; hire?: "driving"|"chauffeured"|"event"; hours?: number }
export function readAgentSelection(qs: URLSearchParams): AgentSelection {
  const args: Record<string,unknown>={};
  for(const key of ["start","end","hire"]) { const value=qs.get(key);if(value)args[key]=value; }
  if(qs.has("hours"))args.hours=Number(qs.get("hours"));
  const {id,...properties}=PUBLIC_INPUTS.get_car_details.properties;
  if(validatePublic({type:"object",properties,additionalProperties:false},args))return {};
  if(args.start && args.end && String(args.end)<String(args.start))return {};
  if(args.hours != null && ["chauffeured","event"].includes(String(args.hire)) && args.start && args.end) {
    try {
      if(args.hire==="chauffeured" && (Number(args.hours)>23 || args.start!==args.end))return {};
      agentQuoteQuery({car_id:1,date_from:args.start,date_to:args.end,rental_type:args.hire,hours:args.hours});
    } catch{return {};}
  }
  return args as AgentSelection;
}
export function agentSelectionTimes(selection:AgentSelection) {
  if(!selection.hours || !selection.hire || selection.hire==="driving")return {};
  const pickup=selection.hire==="chauffeured" && selection.hours<=14 ? 9 : 0;
  const end=pickup+selection.hours;
  if(selection.hire==="chauffeured" && end>=24)return {};
  return {pickup:`${String(pickup).padStart(2,"0")}:00`,dropoff:`${String(end%24).padStart(2,"0")}:00`};
}
export const AGENT_FILL_EVENT="bac:agent-fill-booking";
